import { SET_SELECTED_STORE } from '../../actions/OrderOpportunities/orderOpportunitiesCountdownAction';
import { ISelectedStore } from '../../types';

const initialState:ISelectedStore = {
  externalId: null,
};

const orderOpportunitesStoreReducer = (state = initialState, action: any) => {
  if (action.type === SET_SELECTED_STORE) {
    return { ...state, externalId: action.payload };
  }
  return state;
};

export default orderOpportunitesStoreReducer;
